import styled from '@emotion/styled';

import Tooltip from 'components/global/Tooltip';

import { Breakpoints } from 'utils/const.styles';

export const ChartHeaderWrapper = styled.div`
	margin-bottom: ${({ gutterBottom }) => (gutterBottom ? '2rem' : '0')};
`;

export const ChartHeaderStyled = styled.div`
	width: 100%;
	min-height: 5rem;
	display: grid;
	grid-template-columns: auto 1fr;
	align-items: center;
	margin-bottom: var(--margin-3);

	@media ${Breakpoints.mobile} {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		place-content: flex-start;
		gap: 1rem;
	}
`;

export const ChartFilterStyled = styled.div`
	justify-self: end;

	@media ${Breakpoints.mobile} {
		width: 100%;
	}
`;

export const ChartTitleStyled = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	justify-self: start;
	margin-bottom: 1rem;
`;

export const ChartTitleTootlipStyled = styled(Tooltip)`
	color: #878b97;
	text-align: right;
`;

export const ComparisonFilters = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
`;

export const DynamicListChartContainer = styled.div`
	> div {
		border: none;
	}
`;

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: var(--border-color);
	margin: var(--margin-2) 0 var(--margin-5);
`;
